import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import ActionButton from './ActionButton';

const DeleteButton = ({ onClick, title = "Delete", className = "" }) => {
  return (
    <ActionButton
      icon={FiTrash2}
      onClick={onClick}
      title={title}
      className={`delete-btn ${className}`}
    />
  );
};

export default DeleteButton;
